module.exports = " <div> <div ng-include=\"'customStyle'\"></div> <div ng-include=\"'header-products'\"></div> <div ng-include=\"'products-list'\"></div> <div ng-include=\"'products-details'\"></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/research/products/list/productsList.html
// module id = 616
// module chunks = 0